<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Member
            </th>
            <th class="text-left">
              Contributions (Rs.)
            </th>
            <th class="text-left" v-if="showDelete">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in memberContributions" :key="item.uuid">
            <td v-if="item.member">{{ item.member.display_name }}</td>
            <td>{{ item.contributions }}</td>
            <td v-if="showDelete">
              <v-icon color="red" @click="deleteContribution(item.uuid)">
                mdi-delete-circle
              </v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "MemberContributionList",

  props: ["memberContributions", "project", "showDelete"],
  components: {},

  data: () => ({
    loading: false,
    role: localStorage.getItem("role") || null,
    clubId: localStorage.getItem("club_id") || null,
  }),

  methods: {
    deleteContribution(id) {
      this.$emit('deleteContribution', id);
    }
  },
};
</script>
